import React from "react";
import { ReactElement } from "react";

import MissionVisionPage from "./pages/MissionVisionPage";
import TokenomicsPage from "./pages/TokenomicsPage";
import DashboardPage from "./pages/DashboardPage";
import RoadmapPage from "./pages/RoadmapPage";
import ContactPage from "./pages/ContactPage";
import UcWavesPage from "./pages/UcWavesPage";
import CommingSoon from "./pages/CommingSoon";
import BlogPage from "./pages/BlogPage";
import NotFound from "./pages/NotFound";
import HomePage from "./pages/HomePage";
import Stack from "./pages/StackPage";
import DApp from "./pages/dApp";

import TermsOfService from "./components/footer/TermsOfService";
import PrivacyPolicy from "./components/footer/PrivacyPolicy";
import LegalNotice from "./components/footer/LegalNotice";
import AboutUs from "./components/footer/AboutUs";

// Define shape of a route entry: path and component
interface AppRoute {
  path: string;
  element: ReactElement;
}

// Application routes configuration
export const routes: AppRoute[] = [
  { path: "/Home", element: React.createElement(HomePage) }, // Home page route
  { path: "/HowItWorks", element: React.createElement(UcWavesPage) }, // How It Works overview
  { path: "/Tokenomics", element: React.createElement(TokenomicsPage) }, // Tokenomics information
  { path: "/Roadmap", element: React.createElement(RoadmapPage) }, // Project roadmap
  { path: "/Mission-Vision", element: React.createElement(MissionVisionPage) }, // Mission & Vision
  { path: "/Stack", element: React.createElement(Stack) }, // Technology stack
  { path: "/Dashboard", element: React.createElement(DashboardPage) }, // User dashboard
  { path: "/Blog", element: React.createElement(BlogPage) }, // Blog listing
  { path: "/Contact", element: React.createElement(ContactPage) }, // Contact form
  { path: "/DApp", element: React.createElement(DApp) }, // DApp integration
  { path: "/Legal-notice", element: React.createElement(LegalNotice) }, // Legal notice footer
  { path: "/comming-soon", element: React.createElement(CommingSoon) }, // Coming Soon placeholder
  { path: "/terms", element: React.createElement(TermsOfService) }, // Terms of service
  { path: "/privacy-policy", element: React.createElement(PrivacyPolicy) }, // Privacy policy
  { path: "/about", element: React.createElement(AboutUs) }, // About us info

  // Fallback route for unmatched paths
  { path: "*", element: React.createElement(NotFound) }, // 404 Not Found
];
